import { exists } from "../../../_helper/util.helper";

/**
 * Settings for configuring the display of the form.
 */
export class SettingsConfigModel {

  public showAll: boolean = true;
  public showHints: boolean = true;
  public showMax: boolean = true;
  public imageColumns: number = null;
  public fileColumns: number = null;
  public defaultUnits: 'imperial' | 'metric' = null;
  public displayUnits: 'imperial' | 'metric' = null;

  constructor(model?: Partial<SettingsConfigModel>) {
    if (model) {
      for (let key in this as SettingsConfigModel)
        if (exists(model[key]))
          this[key] = model[key];
    }
    if (![ 'imperial', 'metric' ].includes(this.defaultUnits)) this.defaultUnits = null;
    if (![ 'imperial', 'metric' ].includes(this.displayUnits)) this.displayUnits = this.defaultUnits;
  }
}
